<template>
  <v-container fluid>
    <h2 class="title-style">
      <v-icon class="icon-style">
        mdi-apps
      </v-icon>  Product Details
    </h2>
    <br>
    <v-btn
      color="red darken-3"
      @click="back()"
    >
      back
    </v-btn>
    <br>
    <v-card
      shaped
      color="#CFD8DC"
    >
      <br>
      <v-row>
        <v-col cols="6">
          <v-card
            class="my-card-style"
          >
            <v-card-title class="justify-center">
              <h3
                class="my-2"
                style="color:#37474F"
              >
                Product Details
              </h3>
            </v-card-title>
            <v-col
              cols="6"
              lg="6"
              class="text-right"
            />
            <v-container
              fluid
            >
              <div v-if="Object.keys(selectedProduct).length > 0">
                <p class="my-p-style">
                  Product Name:-
                  <font
                    class="font-my-style"
                  >
                    {{ selectedProduct.name }}
                  </font>
                </p>
                <p class="my-p-style">
                  Type:-
                  <font
                    class="font-my-style"
                  >
                    {{ selectedProduct.type }}
                  </font>
                </p>
                <p class="my-p-style">
                  Status:-
                  <font
                    :color="getColor(selectedProduct.active)"
                  >
                    {{ selectedProduct.active | statusUpdate }}
                  </font>
                </p>
                <p class="my-p-style">
                  Product Description:-
                  <font
                    class="font-my-style"
                  >
                    {{ selectedProduct.description }}
                  </font>
                </p>
                <p class="my-p-style">
                  Product Tier:-
                  <font
                    class="font-my-style"
                  >
                    {{ selectedProduct.product_tier.toUpperCase() }}
                  </font>
                </p>
                <p class="my-p-style">
                  Created At:-
                  <font
                    class="font-my-style"
                  >
                    {{ selectedProduct.created_at | convertStringToLocalDatetime }}
                  </font>
                </p>
              </div>
            </v-container>
          </v-card>
        </v-col>
      </v-row>
      <v-container
        id="regular-tables"
        fluid
        tag="section"
      >
        <v-card
          shaped
          color="#ECEFF1"
        >
          <br>
          <h2 class="price-header">
            Price Details
          </h2>
          <v-col
            cols="12"
            class="text-right"
          >
            <v-btn
              color="#FF3700"
              @click="addPrice()"
            >
              Add Price
            </v-btn>
          </v-col>
          <v-card-title>
            <v-row>
              <v-col
                cols="12"
                lg="4"
              >
                <v-text-field
                  v-model="search"
                  dense
                  label="Search"
                  append-icon="mdi-magnify"
                  outlined
                />
              </v-col>
            </v-row>
          </v-card-title>
          <v-data-table
            :headers="headers"
            :items="priceDetails"
            :search="search"
            class="elevation-1"
          >
            <template #item="{ item }">
              <tr>
                <td>{{ item.name }}</td>
                <td>
                  <font v-if="item.recurring_price===null">
                    3 Years
                  </font><font v-else>
                    {{ item.recurring_price.interval_count }} {{ item.recurring_price.interval }}
                  </font>
                </td>
                <td>{{ item.currency.toUpperCase() }} {{ item.amount | ConvertAmount }}</td>
                <td>{{ item.currency.toUpperCase() }} {{ item.display_price }}</td>
                <td>{{ item.type | pricingType }}</td>
                <td>{{ item.tax_behavior }}</td>
                <td>
                  <font
                    :color="getColor(item.active)"
                    class="font-status-style"
                  >
                    {{ item.active | statusUpdate }}
                  </font>
                </td>
                <td>
                  <v-btn
                    class="mt-n2"
                    elevation="1"
                    fab
                    color="#37474F"
                    x-small
                    icon
                    @click="editPriceStatus(item.active, item.id)"
                  >
                    <v-icon>mdi-pencil</v-icon>
                  </v-btn>
                </td>
              </tr>
            </template>
          </v-data-table>
          <br>
        </v-card>
        <br>
      </v-container>
    </v-card>
    <add-prices
      v-if="showAddPriceForm"
      @closed="showAddPriceForm = false"
      @get-price-details="getPriceList()"
    />
    <edit-price-status
      v-if="showEditForm"
      :status="priceStatus"
      :price-id="priceId"
      @success="getPriceList"
      @closed="showEditForm = false"
    />
    <centre-spinner
      :loading="loading"
    />
  </v-container>
</template>
<script>
  import spinner from 'src/views/dashboard/component/SpinnerCentre';
  import addPrices from 'src/views/dashboard/payments/addPrices.vue';
  import EditPriceStatus from 'src/views/dashboard/payments/EditPriceStatus.vue';
  import moment from 'moment';

  export default {
    name: 'ProductDetails',
    components: {
      'centre-spinner': spinner,
      'add-prices': addPrices,
      'edit-price-status': EditPriceStatus,
    },
    filters: {
      convertStringToLocalDatetime (stringDatetime) {
        return moment(stringDatetime).local().format('Do MMMM YYYY hh:mm A');
      },
      statusUpdate (active) {
        if (active === true) {
          return 'Active*';
        } else {
          return 'Inactive';
        }
      },
      pricingType (pricingType) {
        if (pricingType === 'one_time') {
          return 'One-time';
        } else {
          return 'Recurring';
        }
      },
      ConvertAmount (amount) {
        return amount / 100;
      },
    },
    data () {
      return {
        search: '',
        loading: false,
        productId: '',
        selectedProduct: {},
        headers: [
          { text: 'Pricing Name', align: 'start', value: 'name' },
          { text: 'Pricing Period', value: 'interval_count' },
          { text: 'Total Amount', value: 'amount' },
          { text: 'Monthly (For Display)', value: 'currency' },
          { text: 'Pricing Type', value: 'type' },
          { text: 'Tax Behavior', value: 'tax_behavior' },
          { text: 'Status', value: 'active' },
          { text: 'Edit Status', value: 'edit' },
        ],
        showAddPriceForm: false,
        showEditForm: false,
        priceStatus: '',
        priceId: '',
      };
    },
    computed: {
      productList () {
        return this.$store.getters['payments/getProductsList'];
      },
      priceDetails () {
        return this.$store.getters['payments/getPriceDetails'];
      },
    },
    async mounted () {
      await this.getProductList();
      await this.getPriceList();
    },
    methods: {
      async getProductList () {
        this.productId = this.$route.params.productid;
        this.loading = true;
        await this.$store.dispatch('payments/fetchProductsList').then(response => {
          this.findSelectedProduct();
        });
        this.loading = false;
      },
      findSelectedProduct () {
        this.selectedProduct = this.productList.find(
          product => product.id === this.productId);
      },
      getColor (status) {
        if (status === true) {
          return '#2E7D32';
        } else {
          return '#C62828';
        }
      },
      addPrice () {
        this.showAddPriceForm = true;
      },
      async getPriceList () {
        this.loading = true;
        await this.$store.dispatch('payments/fetchPriceDetails', { productId: this.productId });
        this.loading = false;
      },
      back () {
        this.$router.push({ name: 'Payments' });
      },
      editPriceStatus (priceStatus, priceId) {
        this.showEditForm = true;
        this.priceStatus = priceStatus;
        this.priceId = priceId;
      },
    },
  };
</script>
<style scoped>
.title-style {
  color: #37474F;
}
.icon-style {
  color: #37474F;
  font-size: 45px;
}
.font-my-style {
  font-weight: bold;
  font-size: 15px;
  color: #37474F;
}
.my-card-style {
    border-radius: 15px;
    background-color: #ECEFF1;
    margin-left: 20px;
}
.my-p-style {
    font-size: 16px;
    font-weight: bold;
    color: #546E7A;
    font-family:Cambria, Cochin, Georgia, Times, 'Times New Roman', serif;
}
.v-data-table::v-deep th {
  font-size: 12px !important;
  color: #37474F !important;
  font-weight: bold !important;
}
.v-data-table::v-deep td {
  font-size: 13px !important;
  color: #37474F !important;
}
.v-data-table { background-color: #ECEFF1; }
.theme--light.v-data-table tbody tr:nth-of-type(even) {
  background-color: #CFD8DC
}
.font-status-style {
  font-weight: bold;
}
.price-header {
  color: #37474F;
  text-align: center;
}
</style>
